"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortableTable = exports.OrderDirection = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var OrderDirection;

(function (OrderDirection) {
  OrderDirection["Asc"] = "ASC";
  OrderDirection["Desc"] = "DESC";
})(OrderDirection = exports.OrderDirection || (exports.OrderDirection = {}));

function getSortOrder(key, orderBy, orderDirection) {
  if (orderBy === key) {
    return orderDirection === OrderDirection.Desc ? 'descend' : 'ascend';
  } else {
    return null;
  }
}

function SortableTable(_a) {
  var _b;

  var orderBy = _a.orderBy,
      orderDirection = _a.orderDirection,
      onSortChange = _a.onSortChange,
      _onChange = _a.onChange,
      tableProps = __rest(_a, ["orderBy", "orderDirection", "onSortChange", "onChange"]);

  return react_1["default"].createElement(antd_1.Table, Object.assign({}, tableProps, {
    columns: (_b = tableProps.columns) === null || _b === void 0 ? void 0 : _b.map(function (column) {
      var _a;

      return Object.assign(Object.assign({}, column), {
        sortOrder: column.sorter && column.key && orderBy && orderDirection ? getSortOrder((_a = column.key) === null || _a === void 0 ? void 0 : _a.toString(), orderBy, orderDirection) : undefined
      });
    }),
    onChange: function onChange(pagination, filters, sorter) {
      if (_onChange) {
        for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          args[_key - 3] = arguments[_key];
        }

        _onChange.apply(void 0, [pagination, filters, sorter].concat(args));
      }

      if (onSortChange && sorter && !Array.isArray(sorter) && sorter.columnKey && sorter.order) {
        onSortChange(sorter.columnKey.toString(), sorter.order === 'descend' ? OrderDirection.Desc : OrderDirection.Asc);
      } else if (onSortChange) {
        onSortChange(orderBy, orderDirection === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc);
      }
    }
  }));
}

exports.SortableTable = SortableTable;